import { render, staticRenderFns } from "./VoucherDetail.vue?vue&type=template&id=4f4d1cff&scoped=true"
import script from "./VoucherDetail.vue?vue&type=script&lang=js"
export * from "./VoucherDetail.vue?vue&type=script&lang=js"
import style0 from "./VoucherDetail.vue?vue&type=style&index=0&id=4f4d1cff&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d1cff",
  null
  
)

export default component.exports